document.querySelectorAll('.bar-chart-bar[data-width]').forEach((bar) => {
  bar.style.setProperty('--width', bar.dataset.width);
});
